<template>
	<div>
		<!-- <el-date-picker v-model="timeRange" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
		:default-time="['00:00:00']">
		</el-date-picker> -->
		<el-button :loading="loading" @click="getUserInfo">查询</el-button>
		<el-button @click="exportExcel">导出</el-button>
		<el-table :data="userInfo" border style="width: 100%" v-loading="loading">
			<el-table-column prop="user_phone" label="用户电话" width="180">
			</el-table-column>
			<el-table-column prop="create_time" label="注册时间">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import XLSX from 'xlsx';
import {
	mapState
} from "vuex";
import {
	getUsers
} from "../api/index.js"
export default {
	data() {
		return {
			userInfo:[],
			loading:false
		}
	},
	computed:{
		...mapState([
			"app_info"
		]),
	},
	methods:{
		getUserInfo:function(){
			getUsers({webapp_key:this.app_info.webapp_key}).then(res=>{
				if(res.data.code==200){
					this.userInfo = res.data.user_list
				}
			})
		},
		exportExcel() {
			if (this.userInfo.length > 0) {
				var datajson=[{user_phone:"用户电话",create_time:"注册时间"},...this.userInfo]
				var ws=XLSX.utils.json_to_sheet(datajson, {header:["user_phone","create_time"],skipHeader:true});
				var wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, "file");
				return XLSX.writeFile(wb, '当前查询的注册用户.xlsx');
			} else {
				this.$message.error('无信息可导出')
			}
		},
	}
}
</script>

<style scoped="scoped">
</style>
